// extracted by mini-css-extract-plugin
module.exports = {"container":"bG_x","checkbox":"bG_fg","box":"bG_dH","textContainer":"bG_fh","error":"bG_bZ"};